exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account__flex-item[data-v-70503adf]{margin:20px 0;margin:1.25rem 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;line-height:1.6;width:100%}@media (max-width:599px){.account__flex-item[data-v-70503adf]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.account__flex-item--left[data-v-70503adf]{width:45%;min-width:45%}@media (max-width:599px){.account__flex-item--left[data-v-70503adf]{width:100%}}.account__flex-item--rigth[data-v-70503adf]{max-width:45%}@media (max-width:599px){.account__flex-item--rigth[data-v-70503adf]{max-width:0}}.account__flex-item a[data-v-70503adf]{white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-70503adf","scoped":true,"hasInlineConfig":false}!./~/postcss-loader!./~/sass-loader/lib/loader.js!./app/components/account/style.scss
// module id = 250
// module chunks = 0